import lazyLoading from './lazyLoading'

export default {
  name: 'HomeNet Brand Info',
  path: '/homenet/brandinfo',
  redirect: '/homenet/brandinfo/info',
  meta: {
    auth: ['user'],
    icon: 'fas fa-cube',
    expanded: false
  },
  component: lazyLoading('homenet', true),
  children: [
    {
      'name': 'Info',
      'path': 'info',
      'meta': {
        'label': 'Info'
      },
      'component': lazyLoading('homenet/BrandInfo')
    }
  ]
}



// WEBPACK FOOTER //
// ./client/store/modules/menu/brandInfo.js